import { ReactElement } from 'react'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { OpsPromptsProvider } from './OpsPromptsContext'
import { PromptsPanelComponent } from './PromptsPanelComponent'

export function OpsPromptsLayoutComponent(): ReactElement {
  return (
    <PageScroll
      header={
        <PageHeaderComponent
          title="Prompts"
          subTitle="Manage call-processing prompt templates and review save history."
        />
      }
      contentClassName="pb-14 pt-6"
    >
      <OpsPromptsProvider>
        <PromptsPanelComponent />
      </OpsPromptsProvider>
    </PageScroll>
  )
}
